<script setup lang="ts">
import type { menusitemType } from './type'
import { useUserStore } from '~~/stores/user'

const userStore = useUserStore()
const userDetail = computed(() => userStore.state.userDetail)
const menusitem = ref<menusitemType[]>([
  {
    key: 'profil',
    path: '/user',
    label: 'Profil Saya'
  },
  {
    key: 'studi-saya',
    path: '/user/studi-saya',
    label: 'Studi Saya'
  },
  {
    key: 'wishlist',
    path: '/user/wishlist',
    label: 'Wishlist'
  },
  {
    key: 'playlist',
    path: '/partnerplaylist',
    label: 'Playlists'
  },
  {
    key: 'riwayat-transaksi',
    path: '/user/riwayat-transaksi',
    label: 'Riwayat Transaksi'
  }
])
</script>

<template>
  <div class="account-sidebar">
    <div class="account-sidebar__info">
      <a-avatar :size="64">
        <template #icon>
          <UserOutlined />
        </template>
      </a-avatar>

      <div class="info-name">
        {{ userDetail?.data?.fullName ?? userDetail?.data?.email }}
      </div>
    </div>
    <ul class="account-sidebar__menu">
      <li v-for="menu in menusitem" :key="menu.key">
        <NuxtLink :to="menu.path">{{ menu.label }}</NuxtLink>
      </li>
    </ul>
  </div>
</template>

<style lang="scss">
@use './styles.scss';
</style>
